import { useMutation, useQueryClient } from 'react-query';
import { DRAFT_NAME_CHANGE_DOCUMENT_TYPE } from 'shared/constants';
import { useService } from 'shared/providers';

export function useDeleteDraftNameChange() {
  const { draftNameChangeService } = useService();
  const queryClient = useQueryClient();
  const mutation = useMutation<void, Error, string>(request => draftNameChangeService.deleteDraftNameChange(request), {
    onSuccess: () => {
      queryClient.invalidateQueries(DRAFT_NAME_CHANGE_DOCUMENT_TYPE);
    },
  });

  return mutation;
}
